import React from 'react';
import { Badge, Text } from '@oneaudi/unified-web-components';
import { AvailableBadgeWrapper } from './styles/CarinfoWrapper.styles';
import { getAvailabilityDetails } from '../../utils/getAvailabilityDetails';
import { footnoteRegEx, PlainTextWithFootnotes } from '../../../components';
import styled from 'styled-components';
import { SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_LIGHT } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper } from '../../utils';
import { SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_DARK } from '@oneaudi/unified-web-alpha-common';
export const AvailableBadge = ({ vehicleBasic, isPLP }) => {
    var _a;
    const businessModel = (vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel)
        ? (_a = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel) === null || _a === void 0 ? void 0 : _a.code
        : 'dealer_stock';
    const carType = (vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.type.toUpperCase()) === 'U' ? 'uc' : 'nc';
    const { color, availabilityLabel } = getAvailabilityDetails(carType, businessModel, vehicleBasic.availableFrom, vehicleBasic.availableFromCode, vehicleBasic.reservation, vehicleBasic.dealer.city);
    const labelWithFootNote = (React.createElement("span", { "aria-label": availabilityLabel === null || availabilityLabel === void 0 ? void 0 : availabilityLabel.replace(footnoteRegEx, '') },
        React.createElement(PlainTextWithFootnotes, { text: availabilityLabel })));
    return (React.createElement(AvailableBadgeWrapper, { isPLP: isPLP },
        React.createElement(StyledBadge, { margin: [0, 0, 0, 0], semanticShape: color }),
        React.createElement(StyledText, { variant: {
                order: dynamicStylingHelper('2', '3'),
                style: 'normal',
                type: 'copy',
            } }, labelWithFootNote)));
};
const StyledBadge = styled((props) => React.createElement(Badge, Object.assign({}, props))) `
  margin-top: 6px;
`;
const StyledText = styled((props) => React.createElement(Text, Object.assign({}, props))) `
  color: ${dynamicStylingHelper(SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_LIGHT, SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_DARK)};
`;
